export const experience = [
  {
    company: "You",
    title: "Full Stack Developer",
    type: "work",
    logo: "./img/question-logo.png",
    banner: "",
    start: "",
    end: "",
    location: "USA",
    description: [
      "Developing front-end and back-end applications",
      "Learning and implementing modern technologies",
      "Designing and developing APIs",
      "Bringing a positive, enthusiastic attitude to the toughest of challenges",
      "Coming up with unique solutions",
      "Maintaining good documentation",
      "Writing the most fantastic unit-tests",
      "Ensuring responsiveness of applications",
    ],
  },
  {
    company: "Freelance",
    title: "Full Stack Developer",
    type: "work",
    logo: "./img/freelance.png",
    banner: "./img/freelance-banner.PNG",
    start: "1/23",
    end: "current",
    location: "Remote",
    description: [
      "Designed and built efficient, well-documented, and reusable code while balancing multiple projects in a team environment",
      "Defined user stories, compartmentalized them into actionable tasks, and distributed them to proper teams",
      "Instituted development environment with linter (ESLint), code formatter (Prettier) and type safety (JSDoc) for uniformity",
      "Collaborated with a team of diverse developers using Agile methodologies, JIRA, and Confluence",
      "Implemented WebSocket API to build an event-driven microservice for chat messaging application",
      "Documented REST API and models to OpenAPI specifications with Swagger and created error logging/handling middleware",
      "Automated unit, integration, and end-to-end test suites with Jest, Mocha, Selenium, and Postman to ensure 100% coverage",
    ],
  },
  {
    company: "General Assembly",
    title: "Software Engineer Fellow",
    type: "education",
    logo: "./img/GA-logo.png",
    banner: "./img/ga-logotype_black.png",
    start: "8/22",
    end: "11/22",
    location: "Remote",
    description: [
      `Completed an expert-led, 500+ hour, 12-week intensive software engineering bootcamp, gaining familiarity with modern
      web frameworks (React) and industry-standard programming languages and tools (Javascript, Node.js, MongoDB, Git)`,
      "Mentored colleagues by explaining technical information to a non-technical audience and provided functional code reviews",
      `Developed multiple web applications from ideation to deployment, gaining practical experience with the full software
      development lifecycle and project management methodologies`,
      `Demonstrated a strong ability to learn and adapt quickly to new technologies and programming languages, as evidenced by
      consistent growth and improvement through the bootcamp`,
    ],
  },
  {
    company: "Neurovex",
    title: "Operations Manager",
    type: "work",
    logo: "./img/neurovex-logo.PNG",
    banner: "./img/neurovex-banner.PNG",
    color: "#1a1a1a",
    start: "08/19",
    end: "05/22",
    location: "Miami, FL",
    description: [
      "Completed a full build-out of a 6000 sq ft turn-key hemp extraction facility",
      "Built and managed relationships with vendors and conducted negotiations to secure optimal pricing for materials",
      "Developed and implemented company SOPs to meet safety regulations and ensure GMP compliance",
      "Coordinated all aspects of logistics for a supply chain extracting 30K pounds of hemp per month",
      "Performed thorough market research and competitive analysis to effectively communicate product value proposition",
    ],
  },
  {
    company: "Holmdel Buy-Rite",
    title: "Craft Beer Manager",
    type: "work",
    logo: "./img/buyrite-logo.PNG",
    banner: "./img/buyrite-banner.png",
    start: "10/17",
    end: "08/19",
    location: "Holmdel, NJ",
    description: [
      "Managed and reported financial statements; wrote Python + Excel program to automate 90% of the work",
      "Oversaw all aspects of the hiring process, developed a results-driven culture centered on accountability and collaboration",
      "Expanded the craft beer department’s selection and quality, more than doubling it in size",
      "Spearheaded marketing strategies and increased overall sales and revenue by 15%",
      "Reorganized and updated store layout to maximize physical goods capacity by 10%",
    ],
  },
  {
    company: "Dell EMC",
    title: "Electrical Design Engineer Co-op",
    type: "work",
    logo: "./img/dell-logo.avif",
    banner: "./img/dellemc-banner.png",
    start: "07/16",
    end: "01/17",
    location: "Hopkinton, MA",
    description: [
      "Wrote maintainable and extensible firmware in C++ in an Agile team environment",
      "Consulted with engineering staff to evaluate interface between hardware and software",
      "Performed in-depth quality testing of completed hardware, including continuity and ESD testing",
      "Rendered technical drawings and electrical systems specifications",
      "Received a monetary award of $1000 for exceeding expectations assisting the QA team",
    ],
  },
  {
    company: "name",
    title: "B.S. Computer Engineering",
    type: "education",
    logo: "./img/neu-logo.png",
    banner: "./img/neu-banner.png",
    color: "#cc0000",
    start: "",
    end: "05/17",
    location: "Boston, MA",
    description: [],
  },
];
